import "./default-config"
export {VERSION} from "./VERSION"
export {query} from "./exec/query"
export {mutate} from "./exec/mutate"
export {verifyUserSignatures} from "./exec/verify"
export {serialize} from "./serialize"
export {transaction as tx} from "./transaction"
export {events} from "./events"

import {currentUser} from "./current-user"
export {currentUser}

import {discovery} from "./discovery"
export {discovery}

export const authenticate = (opts = {}) => currentUser().authenticate(opts)
export const unauthenticate = () => currentUser().unauthenticate()
export const reauthenticate = (opts = {}) => {
  currentUser().unauthenticate()
  return currentUser().authenticate(opts)
}
export const signUp = (opts = {}) => currentUser().authenticate(opts)
export const logIn = (opts = {}) => currentUser().authenticate(opts)

export const authz = currentUser().authorization

import * as types from "@onflow/types"
export const t = types

import * as WalletUtils from "./wallet-utils"
export {WalletUtils}

export {TestUtils} from "@dimensiondev/onflow-sdk"
export {config} from "@dimensiondev/onflow-sdk"
export {send} from "@dimensiondev/onflow-sdk"
export {decode} from "@dimensiondev/onflow-sdk"
export {account} from "@dimensiondev/onflow-sdk"
export {latestBlock} from "@dimensiondev/onflow-sdk"
export {isOk, isBad, why, pipe, build} from "@dimensiondev/onflow-sdk"
export {withPrefix, sansPrefix, display} from "@onflow/util-address"
export {template as cadence} from "@onflow/util-template"
export {template as cdc} from "@onflow/util-template"
export {createSignableVoucher} from "@dimensiondev/onflow-sdk"

// builders
export {transaction} from "@dimensiondev/onflow-sdk"
export {script} from "@dimensiondev/onflow-sdk"
export {ping} from "@dimensiondev/onflow-sdk"
export {atBlockHeight} from "@dimensiondev/onflow-sdk"
export {atBlockId} from "@dimensiondev/onflow-sdk"
export {getAccount} from "@dimensiondev/onflow-sdk"
export {getEvents} from "@dimensiondev/onflow-sdk"
export {getEventsAtBlockHeightRange} from "@dimensiondev/onflow-sdk"
export {getEventsAtBlockIds} from "@dimensiondev/onflow-sdk"
export {getLatestBlock} from "@dimensiondev/onflow-sdk"
export {getBlock} from "@dimensiondev/onflow-sdk"
export {getBlockHeader} from "@dimensiondev/onflow-sdk"
export {getBlockById} from "@dimensiondev/onflow-sdk"
export {getBlockByHeight} from "@dimensiondev/onflow-sdk"
export {getCollection} from "@dimensiondev/onflow-sdk"
export {getTransactionStatus} from "@dimensiondev/onflow-sdk"
export {getTransaction} from "@dimensiondev/onflow-sdk"
export {authorizations, authorization} from "@dimensiondev/onflow-sdk"
export {args, arg} from "@dimensiondev/onflow-sdk"
export {proposer} from "@dimensiondev/onflow-sdk"
export {payer} from "@dimensiondev/onflow-sdk"
export {limit} from "@dimensiondev/onflow-sdk"
export {ref} from "@dimensiondev/onflow-sdk"
export {params, param} from "@dimensiondev/onflow-sdk"
export {validator} from "@dimensiondev/onflow-sdk"
export {invariant} from "@dimensiondev/onflow-sdk"
